// eslint-disable-next-line
export const SET_PAGE = 'pagination/set-page';
